"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationObjectsMap = (function (_super) {
    tslib_1.__extends(AnimationObjectsMap, _super);
    function AnimationObjectsMap(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.findById = function (id) {
            return _this.backingMap[id];
        };
        _this.elementAt = function (index) {
            return _this.backingArray[index];
        };
        _this.forEach = function (operation) {
            _this.backingArray.forEach(operation);
        };
        _this.filter = function (filter) {
            return _this.backingArray.filter(filter);
        };
        _this.push = function (element) {
            var key = _this.getElementKey(element);
            var old = _this.findById(key);
            if (old === undefined) {
                _this.backingMap[key] = element;
                _this.backingArray.push(element);
            }
            else {
                throw new Error("Duplicate registration of element " + JSON.stringify(element) + ". Key " + key + " already exists");
            }
        };
        _this.remove = function (element) {
            var key = _this.getElementKey(element);
            var old = _this.findById(key);
            if (old !== undefined) {
                var index = _this.backingArray.findIndex(function (candidate) { var candidateKey = _this.getElementKey(candidate); return candidateKey === key; });
                _this.backingArray.splice(index, 1);
                delete _this.backingMap[key];
            }
        };
        _this.clear = function () {
            _this.backingArray = [];
            _this.backingMap = {};
        };
        _this.backingArray = [];
        _this.backingMap = {};
        rawData.forEach(function (elementRawData) {
            var element = _this.importElement(elementRawData, version);
            var key = _this.getElementKey(element);
            _this.backingArray.push(element);
            _this.backingMap[key] = element;
        });
        return _this;
    }
    AnimationObjectsMap.prototype.map = function (callbackFn, thisArg) {
        return this.backingArray.map(callbackFn, thisArg);
    };
    Object.defineProperty(AnimationObjectsMap.prototype, "length", {
        get: function () {
            return this.backingArray.length;
        },
        enumerable: true,
        configurable: true
    });
    AnimationObjectsMap.prototype.toRawData = function () {
        return this.backingArray.map(function (element) {
            return element.toRawData();
        });
    };
    return AnimationObjectsMap;
}(AnimationObject_1.AnimationObject));
exports.AnimationObjectsMap = AnimationObjectsMap;
//# sourceMappingURL=AnimationObjectsMap.js.map